module.exports = __webpack_public_path__ + "img/液冷超充.6e4d50e8.png";